import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import HStreamIDInput from '../Inputs/HStreamIDInput';
import { isPhoneOrEmail, required } from './validate';

const HStreamIDFieldComponent = (props) => {
  const {
    input, meta, disabled, readOnly, busy, label, helpText, id
  } = props;
  const { touched, error } = meta;
  const errorMessage = touched && error ? error : '';
  // Disabled inputs cause Chromium / LastPass to move the credential icon to the
  // left. While busy, keep the field enabled but read-only so the icon stays put.
  const inputDisabled = busy ? false : disabled;
  const inputReadOnly = busy ? true : readOnly;
  return (
    <HStreamIDInput
      id={id}
      type="text"
      label={label}
      helpText={helpText}
      errorMessage={errorMessage}
      {...input}
      disabled={inputDisabled}
      readOnly={inputReadOnly}
      autoComplete="username"
    />
  );
};

const HStreamIDField = ({
  name,
  label,
  disabled,
  readOnly,
  busy,
  helpText,
  id,
}) => (
    <Field
      name={name}
      component={HStreamIDFieldComponent}
      disabled={disabled}
      readOnly={readOnly}
      busy={busy}
      label={label}
      validate={[required, isPhoneOrEmail]}
      helpText={helpText}
      id={id}
    />
  );

HStreamIDField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  busy: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  helpText: PropTypes.string,
};

HStreamIDField.defaultProps = {
  id: undefined,
  disabled: false,
  readOnly: false,
  busy: false,
  label: 'hStream ID',
  helpText: '',
};

export default HStreamIDField;
export { HStreamIDFieldComponent };
